<template>
	<div class="container-xl">
		<main class="py-4">
			<div class="row g-3 mb-4 align-items-center justify-content-between">
				<div class="col-auto">
					<h1 class="app-page-title mb-0">{{ __('schedules.import-schedules-title') }}</h1>
				</div>
                <p></p>
			</div>

            <div class="row g-4 mb-4">
                <div class="col-12">
                    <div class="app-card app-card-basic d-flex flex-column align-items-start shadow-sm">
                        <div class="app-card-header p-3 border-bottom-0">
                            <div class="row align-items-center gx-3">
                                <div class="col-auto">
                                    <h4 class="app-card-title">{{ __('schedules.import-steps-text-title') }}</h4>
                                </div>
                            </div>
                        </div>
                        <div class="app-card-body px-4">

                            <div class="intro">
                                <ol class="ps-3">
                                    <li><a href="/import-schedule/download-template" target="_blank"><u>Download</u></a> {{ __('schedules.import-steps-text-1') }}</li>
                                    <li>{{ __('schedules.import-steps-text-2') }}</li>
                                    <li>{{ __('schedules.import-steps-text-3') }}</li>
                                    <li>{{ __('schedules.import-steps-text-4') }}</li>
                                    <li>{{ __('schedules.import-steps-text-5') }}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row g-4 mb-4">
                <div class="col-12">
                    <div class="app-card app-card-basic d-flex flex-column align-items-start shadow-sm">
                        <div class="app-card-header p-3 border-bottom-0">
                            <div class="row align-items-center gx-3">
                                <div class="col-auto">
                                    <h4 class="app-card-title">{{ __('schedules.select-file-title') }}</h4>
                                </div>
                            </div>
                        </div>
                        <form v-if="showForm">
                            <div class="app-card-body px-4">
                                <div class="form-group row">
                                    <div class="col-md-12">
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" id="customFile"
                                                ref="file" @change="fileHandler()" required/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="app-card-footer p-4 mt-auto">
							   <button
                                    @click.prevent="submit"
                                    type="submit"
                                    class="button"
                                    :class="{ spinning: isProcessing, disabled: isDisabled }"
                                    :disabled="isDisabled"
                                >
                                    {{ __('actions.import') }}
                                </button>
						    </div>
                        </form>
                    </div>
                </div>
            </div>

            <div v-if="errors">
              <div v-for="error in errors" class="alert alert-danger">{{ error }}</div>
            </div>

            <!-- THIS IS THE RESULT BLOCK - SHOWING USER DATA IN CASE OF SUCCESS -->
            <div v-if="message">
              <div class="alert alert-success">{{ message.message }}</div>
            </div>

		</main>
	</div>
</template>

<script>
export default {
    name: 'ImportScheduleComponent',
    data() {
      return {
        formData: null,
        excelFile: null,
        excelFileName: null,
        isProcessing: false,
        isDisabled: true,
        showForm: true,
        message: null,
        errors: null,
        }
    },
    methods: {
        fileHandler() {
            this.excelFile = this.$refs.file.files[0]
            this.excelFileName = this.excelFile.name
            this.isDisabled = false
        },
        submit() {
            this.isProcessing = true
            this.isDisabled = true
            this.errors = null

            let formData = new FormData()
            formData.append('excelFile', this.excelFile)

            axios.post('/import-schedule', formData, {
                headers: {
                    'Content-Type': "multipart/form-data; charset=utf-8;"
                }
            }).then(response => {
                this.showForm = false
                this.message = response.data
            }).catch(err => {
                if (err.response.status === 422) {

                    this.errors = []
                    _.each(err.response.data.errors, error => {
                        _.each(error, e => {
                            this.errors.push(e)
                        })
                    })
                }
            });
        },
    },
}
</script>

<style scoped>
.button {
  display: inline-block;
  outline: none;
  padding: 10px 20px;
  background: #42b983;
  border: #42b983;
  border-radius: 4px;
  color: #fff;
  position: relative;
  transition: padding-right 0.3s ease;
}
.button.disabled {
  background: #a5a5a5;
  border: #a5a5a5;
}
.button.spinning {
  padding-right: 40px;
}
.button.spinning:after {
  content: "";
  right: 6px;
  top: 50%;
  width: 0;
  height: 0;
  position: absolute;
  border-radius: 50%;
  -webkit-animation: rotate360 0.5s infinite linear, exist 0.1s forwards ease;
          animation: rotate360 0.5s infinite linear, exist 0.1s forwards ease;
}
.button.spinning:before {
  content: "";
  width: 0px;
  height: 0px;
  border-radius: 50%;
  right: 6px;
  top: 50%;
  position: absolute;
  border: 2px solid #000000;
  border-right: 3px solid #27ae60;
  -webkit-animation: rotate360 0.5s infinite linear, exist 0.1s forwards ease;
          animation: rotate360 0.5s infinite linear, exist 0.1s forwards ease;
}
@-webkit-keyframes rotate360 {
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes rotate360 {
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@-webkit-keyframes exist {
  100% {
    width: 20px;
    height: 20px;
    margin: -8px 5px 0 0;
  }
}
@keyframes exist {
  100% {
    width: 20px;
    height: 20px;
    margin: -8px 5px 0 0;
  }
}
</style>
